import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "sps-card sps-card-border subflow-records-modal",
  "data-testid": "consult.subflow-records-modal"
}
const _hoisted_2 = { class: "sps-card-content p-0" }
const _hoisted_3 = {
  key: 0,
  class: "sps-alert sps-alert-light",
  "data-testid": "consult.subflow-records-loading"
}
const _hoisted_4 = { class: "sps-alert-content" }
const _hoisted_5 = {
  key: 1,
  class: "sps-alert sps-alert-destructive",
  "data-testid": "consult.subflow-records-error"
}
const _hoisted_6 = { class: "sps-alert-content" }
const _hoisted_7 = {
  key: 2,
  class: "sps-alert sps-alert-light",
  "data-testid": "consult.subflow-records-empty"
}
const _hoisted_8 = { class: "sps-alert-content" }
const _hoisted_9 = {
  key: 3,
  class: "subflow-records-modal__records",
  "data-testid": "consult.subflow-records-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "sps-badge sps-badge-lg sps-badge-outline sps-badge-secondary subflow-records-modal__record-status",
  "data-testid": "consult.subflow-record-status"
}

import { onMounted, ref } from 'vue';

interface SubflowRecord {
    RecordId: number;
    Name: string;
    LifeStatusName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SubflowRecordsModal',
  props: {
    title: {},
    completionLifeStatusName: { default: '' },
    entityId: {},
    load: {},
    loadingText: { default: 'Loading records...' },
    emptyText: { default: 'No unfinished records' }
  },
  emits: ["navigate"],
  setup(__props: any) {

const props = __props;



const records = ref<SubflowRecord[]>([]);
const isLoading = ref(true);
const error = ref('');

onMounted(async () => {
    try {
        records.value = (await props.load()) || [];
    } catch (e: any) {
        error.value = (e && (e.message || e.Message)) || 'Could not load the records';
    } finally {
        isLoading.value = false;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.loadingText), 1 /* TEXT */)
          ]))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(error.value), 1 /* TEXT */)
            ]))
          : (!records.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.emptyText), 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (record) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: record.RecordId,
                    class: "subflow-records-modal__record"
                  }, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      class: "text-base subflow-records-modal__record-name",
                      "data-testid": "consult.subflow-record-name",
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('navigate', record, $event.ctrlKey || $event.metaKey)), ["stop"])
                    }, _toDisplayString(record.Name), 9 /* TEXT, PROPS */, _hoisted_10),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(record.LifeStatusName), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
    ])
  ]))
}
}

})